import * as React from 'react'

import { Button, useToggle } from '@factorialco/deprecated-design-system'

import Popover from 'modules/core/components/Popover'
import PopoverContent from 'modules/core/components/Popover/Content'

import { Folder } from 'modules/documents/hooks/useGetFolders'
import { folderOptions } from 'modules/documents/lib/Folders'

interface Props {
  folder: Folder
  toggleRenameModal: () => void
  toggleDeleteModal: () => void
}
const OptionsButton = ({ folder, toggleRenameModal, toggleDeleteModal }: Props) => {
  const [isButtonSubmenuOpen, setIsButtonSubmenuOpen] = useToggle(false)

  return (
    <Popover
      attachment="top right"
      targetAttachment="bottom center"
      toggle={setIsButtonSubmenuOpen}
      open={isButtonSubmenuOpen}
    >
      <Button
        type="secondary"
        onClick={setIsButtonSubmenuOpen(true)}
        disabled={folder.isReadonly}
        iconName="ellipsis"
      />
      <PopoverContent
        onClose={setIsButtonSubmenuOpen(false)}
        options={folderOptions(toggleRenameModal, toggleDeleteModal)}
      />
    </Popover>
  )
}

export default OptionsButton
